// --- React & Redux
import React from 'react';
// --- External UI Libraries
import { Col, Row } from 'antd';
import Typography from '@dtci/spellbook/Typography';
// --- Components
import { UploadTemplateForm } from './components/upload-form';
import ToastNotificationProvider from '../../components/ToastNotifications';
import OneRowLayout from './one-row';
import { CustomFieldsDrawer } from './components/drawers/custom-fields';
import { SavedTemplatesModal } from './components/modals/saved-templates';

/**
 * Upload Templates Page
 *
 * Features:
 * - Renders a page for uploading templates
 * - Includes a form for uploading templates
 * - Provides modals for custom fields and saved templates
 * - Utilizes a one-row layout
 *
 * @returns {Element}
 * @constructor
 */
export const UploadTemplatesPage = () => {

    return (
        <>
            <Row>
                <Col span={22}>
                    <Typography variant="T50" style={{ marginLeft: 20, marginTop: 20 }}>
                        Upload Templates
                    </Typography>
                </Col>
            </Row>
            <OneRowLayout>
                <main data-position="top">
                    <UploadTemplateForm />
                </main>
            </OneRowLayout>
            <CustomFieldsDrawer />
            <SavedTemplatesModal />
            <ToastNotificationProvider />
        </>
    );
};
